<app-recinto-list
    [mode]="recintoListMode" [readonly]="readonly" [result]="recintoCultivosSolicitud" [lastFilter]="payloadCultivosSolicitud" 
    (search)="onSearchLazy($event)" (view)="onViewHandler($event)" (delete)="onDeleteCultivo($event)" (undoDelete)="onUndoDeleteCultivo($event)"></app-recinto-list>

<!-- Ventana de diálogo para añadir cultivos a la solicitud -->
<ng-container *ngIf="cultivoListDialogVisible">
    <app-recinto-list-dialog [visible]="cultivoListDialogVisible" [dialogFilter]="dialogFilter" (selectedCultivos)="onSelectedCultivos($event)"></app-recinto-list-dialog>
</ng-container>


<!-- Ventana para mostrar el detalle de un recinto PI y sus cultivos -->
<ng-container *ngIf="recintoPIADetailVisible">
    <app-recinto-detail-dialog [visible]="recintoPIADetailVisible" [Id]="recintoPIAIdSelected" [editMode]="false" (closed)="onRecintoDialogClosed($event)"></app-recinto-detail-dialog>
</ng-container>
